import React from 'react';
import PropTypes from 'prop-types';

const TitleLogo = ({ logoUrl, title, alt = '' }) => (logoUrl ? (
  <img className="titleLogo" src={logoUrl} alt={alt} />
) : title);

TitleLogo.propTypes = {
  alt: PropTypes.string,
  logoUrl: PropTypes.string,
  title: PropTypes.string,
};

TitleLogo.defaultProps = {
  alt: '',
  logoUrl: null,
  title: '',
};

export default TitleLogo;
